import React, { useState, useRef } from "react";
import { Carousel, Card, Badge } from "react-bootstrap";
import * as constants from "../../constants/CONSTANT";
const CarouselCards = ({ msg, userInfo, pdfIcon }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const failedImagesRef = useRef({});
  // console.log("msg", msg);
  const [failedImages, setFailedImages] = useState({});
  // Parse template cards
  const getCards = () => {
    try {
      return typeof msg.template_cards === "string"
        ? JSON.parse(msg.template_cards)
        : msg.template_cards || [];
    } catch (error) {
      console.error("Error parsing template cards:", error);
      return [];
    }
  };

  const cards = getCards();

  if (!Array.isArray(cards) || cards.length === 0) {
    return <div className="text-muted">No carousel cards available</div>;
  }
  const formatMessage = (message, params = {}) => {
    if (!message) return "";

    const flatParams = {};

    // Copy top-level numeric keys directly
    Object.entries(params).forEach(([key, value]) => {
      if (!isNaN(key)) {
        flatParams[key] = value;
      }
    });

    // Also flatten nested objects (e.g. 'main')
    Object.keys(params).forEach((key) => {
      if (typeof params[key] === "object" && params[key] !== null) {
        Object.entries(params[key]).forEach(([innerKey, value]) => {
          flatParams[innerKey] = value;
        });
      }
    });

    return message
      .replace(/\*(.*?)\*/g, "<b>$1</b>") // Bold
      .replace(/_(.*?)_/g, "<i>$1</i>") // Italic
      .replace(/~(.*?)~/g, "<s>$1</s>") // Strikethrough
      .replace(/```([\s\S]*?)```/g, "<pre>$1</pre>") // Code block (multiline safe)
      .replace(/\n+/g, "<br />")
      .replace(/{{(\d+)}}/g, (_, index) => {
        const replacement = flatParams[index] || `{{${index}}}`;
        return replacement;
      });
  };

  const renderCardMedia = (card, cardIndex) => {
    if (!msg || !userInfo) return null;

    const mediaStyle = { width: "100%", height: "200px", objectFit: "cover" };
    const param = msg.body_text_params?.[cardIndex];
    let src = "/logo.png";
    let key = cardIndex;
    if (param) {
      // const src = `http://localhost:3000/demo/attachment/${param.file_title}`;
      const encodedFileTitle = encodeURIComponent(param.file_title);
      const src = `${constants.API_BASE_URL}/api/whatsapp/files/preview/${userInfo.tenantcode}/${encodedFileTitle}`;

      if (param.fileType?.toLowerCase() === "image") {
        return (
          <Card.Img
            key={key}
            variant="top"
            src={src}
            alt={param.file_title || `Card ${cardIndex + 1}`}
            style={mediaStyle}
            onError={() => {
              failedImagesRef.current[cardIndex] = true;
              setFailedImages({ ...failedImagesRef.current });
            }}
          />
        );
      }

      if (param.fileType?.toLowerCase() === "video") {
        return (
          <video key={key} controls style={mediaStyle} className="card-img-top">
            <source src={src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );
      }

      if (param.fileType?.toLowerCase() === "document") {
        return (
          <div
            key={key}
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ height: "200px", backgroundColor: "#f8f9fa" }}
          >
            <img
              src={pdfIcon}
              alt="Document"
              style={{ width: "60px", height: "60px" }}
            />
            <small className="text-muted mt-2">Document</small>
            {param.file_title && (
              <small className="text-truncate">{param.file_title}</small>
            )}
          </div>
        );
      }
    }

    return null;
  };

  const renderCardButtons = (card) => {
    if (!card.buttons?.length) return null;

    return (
      <div className="d-grid gap-2 p-3">
        {card.buttons.map((button, btnIndex) => (
          <Badge
            key={btnIndex}
            bg="light"
            text="primary"
            className="p-2 text-center"
            style={{
              fontSize: "0.85rem",
              cursor: "pointer",
              border: "1px solid #dee2e6",
            }}
          >
            {button.text}
          </Badge>
        ))}
      </div>
    );
  };

  // Carousel navigation
  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  return (
    <div className="position-relative">
      <style jsx>{`
        .carousel-control-prev,
        .carousel-control-next {
          width: 30px !important;
          height: 30px !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
          border-radius: 50% !important;
        }
        .carousel-control-prev {
          top: 22px !important;
          left: 1px !important;
        }
        .carousel-control-next {
          right: 1px !important;
        }
        .carousel-control-prev-icon,
        .carousel-control-next-icon {
          width: 10px !important;
          height: 10px !important;
        }
        .btn-sm.rounded-circle {
          width: 25px;
          height: 25px;
          padding: 0;
          font-size: 12px;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>

      {/* Main message body */}
      {msg.message_body && (
        <div className="m-2 ps-1">
          <span
            dangerouslySetInnerHTML={{
              __html: formatMessage(
                msg.message_body,
                msg.body_text_params || msg.campaign_body_text_params || {}
              ),
            }}
          />
        </div>
      )}

      {/* Carousel */}
      <Carousel
        activeIndex={activeIndex}
        onSelect={handleSelect}
        controls={false}
        indicators={false}
        interval={null}
        className="carousel-dark"
      >
        {cards.map((card, cardIndex) => {
          const cardParams = msg.body_text_params?.[String(cardIndex)] || {};
          const mainParams = msg.body_text_params?.main || {};
          const mergedParams = { ...mainParams, ...cardParams };

          return (
            <Carousel.Item key={cardIndex}>
              <Card className="border-0 shadow-sm">
                {renderCardMedia(card, cardIndex)}

                <Card.Body className="p-3">
                  {card.body?.text && (
                    <Card.Text
                      dangerouslySetInnerHTML={{
                        __html: formatMessage(card.body.text, mergedParams),
                      }}
                    />
                  )}
                </Card.Body>

                {renderCardButtons(card)}
              </Card>
            </Carousel.Item>
          );
        })}
      </Carousel>

      {/* Custom Navigation */}
      {cards.length > 1 && (
        <div className="d-flex justify-content-center align-items-center gap-3 mt-2">
          <button
            className="btn btn-outline-secondary btn-sm rounded-circle"
            onClick={() =>
              setActiveIndex((prev) =>
                prev === 0 ? cards.length - 1 : prev - 1
              )
            }
          >
            &lt;
          </button>
          <small className="text-muted fw-medium">
            {activeIndex + 1} of {cards.length}
          </small>
          <button
            className="btn btn-outline-secondary btn-sm rounded-circle"
            onClick={() =>
              setActiveIndex((prev) =>
                prev === cards.length - 1 ? 0 : prev + 1
              )
            }
          >
            &gt;
          </button>
        </div>
      )}
    </div>
  );
};

export default CarouselCards;
